import { useEffect, useState } from 'react';
export const MEGALOS_LIVE_CALENDAR_HIDDEN_AT = new Date('2026-10-01T00:00:00+09:00').getTime();
const MAX_TIMEOUT_MS = 2147483647;
export const isMegalosLiveCalendarVisible = (now = Date.now()) => {
    return now < MEGALOS_LIVE_CALENDAR_HIDDEN_AT;
};
export const useMegalosLiveCalendarVisibility = () => {
    const [isVisible, setIsVisible] = useState(isMegalosLiveCalendarVisible);
    useEffect(() => {
        let timeoutId;
        const updateVisibility = () => {
            const now = Date.now();
            const nextIsVisible = isMegalosLiveCalendarVisible(now);
            setIsVisible(nextIsVisible);
            if (nextIsVisible) {
                timeoutId = window.setTimeout(updateVisibility, Math.min(MEGALOS_LIVE_CALENDAR_HIDDEN_AT - now, MAX_TIMEOUT_MS));
            }
        };
        updateVisibility();
        return () => {
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
            }
        };
    }, []);
    return isVisible;
};
